import {findCurrentShop, getStoreDetails} from "@amzn/rangoli-seller-desktop-fe-auth-utils/src/index";

import Mixpanel from "./MixPanelConfig";

export const removeTags = (str: string) => {
  if ((str = str?.toString())) {
    return str?.replace(/(<([^>]+)>)/gi, "");
  }
  return "";
};

export const triggerMixpanelEvent = (label: string, property: any) => {
  Mixpanel.track(label, property);
};

export const formatTime = (timeInMs: number) => {
  const hours = Math.floor((timeInMs / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeInMs / (1000 * 60)) % 60);
  const seconds = Math.floor((timeInMs / 1000) % 60);
  return {hours, minutes, seconds};
};

export const getShopId = async (): Promise<string> => {
  const shopId = localStorage.getItem("shopId");
  if (shopId) {
    return shopId;
  }
  // Add a fallback to handle cases where no shopId is present.
  else {
    const storeDetails = await getStoreDetails();
    const currentStore = findCurrentShop(storeDetails.data);
    if (currentStore) {
      localStorage.setItem("shopId", currentStore.storeId);
      return currentStore.storeId;
    }
  }
  return shopId;
};

export const getStoreURI = async (): Promise<string> => {
  const storeURI = localStorage.getItem("storeURI");
  if (storeURI) {
    return storeURI;
  }
  // Add a fallback to handle cases where no storeURI is present.
  else {
    const storeDetails = await getStoreDetails();
    const currentStore = findCurrentShop(storeDetails.data);
    if (currentStore) {
      localStorage.setItem("storeURI", currentStore.storeURI);
      return currentStore.storeURI;
    }
  }
  return storeURI;
};
